import { AxiosResponse } from 'axios';
import axios from './axios';

interface IEligibilityCheck {
  isEligibleByLocalities: boolean;
  isEligibleByResponsibleForZIPs: boolean;
}

interface ILocalityNames {
  localityNames: string[];
}

const checkZipCodeEligibility = (zipCode: number | string): Promise<AxiosResponse<IEligibilityCheck>> =>
  axios.get(`/eligibility-check/zip/${zipCode.toString()}/eligibility`);

const getLocalityNamesByZipCode = (zipCode: number | string): Promise<AxiosResponse<ILocalityNames>> =>
  axios.get(`/eligibility-check/zip/${zipCode.toString()}/localities`);

export default { checkZipCodeEligibility, getLocalityNamesByZipCode };
